import Vue from 'vue'
import Vuex from 'vuex'

import admin from './modules/admin'
import colors from './modules/colors'
import copy from './modules/copy'
import header from './modules/header'
import logo from './modules/logo'
import main from './modules/main'
import mainmtr from './modules/mainmtr'
import usuarios from './modules/usuarios'
import info from './modules/info'
import suscripciones from './modules/suscripciones'
import productos from './modules/productos'
import personalizacion from './modules/personalizacion'
import storeOnline from './modules/storeOnline'
import factura from './modules/factura'
import categories from './modules/categories'
import marcas from './modules/marcas'
import atributos from './modules/atributos'
import gallery from './modules/gallery'
import related from './modules/related'
import payment from './modules/payment'
import quotes from './modules/quotes'
import clientList from './modules/clientList'
import sociales from './modules/sociales'
import statistics from './modules/statistics'
import client from './modules/client'
import projects from './modules/projects'
import inversor from './modules/inversor'
import costeador from './modules/costeador'
import supplier from './modules/supplier'
import purchase from './modules/purchase'
import cobranza from './modules/cobranza'
import pagos from './modules/pagos'
import record from './modules/record'
import gastos from './modules/gastos'
import office from './modules/office'
import simple from './modules/simple'
import monitoring from './modules/monitoring'
import income from './modules/income'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    admin,
    colors,
    copy,
    header,
    logo,
    main,
    mainmtr,
    usuarios,
    info,
    suscripciones,
    productos,
    personalizacion,
    storeOnline,
    factura,
    categories,
    marcas,
    atributos,
    gallery,
    related,
    payment,
    quotes,
    clientList,
    sociales,
    statistics,
    client,
    projects,
    inversor,
    costeador,
    supplier,
    purchase,
    cobranza,
    pagos,
    record,
    gastos,
    office,
    simple,
    monitoring,
    income
  }
})
